import type { AttestMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { AttestDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

/**
 * Maps the tRPC mutation response to match the GraphQL mutation
 * response shape so consumers branching on the result do not need
 * to know which path executed.
 */
const mapTrpcResponseToGraphQL = (data: {
  affected_rows: number;
}): AttestMutation => ({
  attestRecord: {
    __typename: 'GenericMutationOutput',
    affected_rows: data.affected_rows,
  },
});

export const useAttestRecord = createMutationHook({
  name: 'attest',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.attestation.attest.mutationOptions({ onSuccess }),
  mapInput: (input: { Id: string }) => ({ Id: input.Id }),
  mapResponse: (result: { affected_rows: number }) =>
    mapTrpcResponseToGraphQL(result),
  invalidate: (trpc) => [
    trpc.frontend.attestation.status.queryKey(),
    // COI-889: attesting from the public policy page only refetches that page's
    // own status query — the register and the version's Attestations tab did not.
    trpc.frontend.attestation.register.queryKey(),
    trpc.frontend.attestation.recordsForDocument.queryKey(),
    // COI-889: the my-items ribbon counts this entity.
    trpc.frontend.myItems.pathKey(),
  ],
  graphqlDocument: AttestDocument,
  graphqlVariables: (input: { Id: string }) => ({ Id: input.Id }),
});
